exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes lighteffect{0%{background-color:hsla(0,0%,100%,.1)}25%{background-color:hsla(0,0%,100%,.2)}50%{background-color:hsla(0,0%,100%,.03)}75%{background-color:hsla(0,0%,100%,.16)}to{background-color:hsla(0,0%,100%,.05)}}@keyframes fadeout{0%{background:rgba(0,0,0,.5)}25%{background:rgba(0,0,0,.7)}50%{background:rgba(0,0,0,.5)}75%{background:rgba(0,0,0,.8)}to{background:#000}}@keyframes red{0%{background:red}to{background:rgba(255,0,0,0)}}.lighteffect{animation-name:lighteffect;z-index:1;animation-iteration-count:infinite;animation-duration:13s;width:100%;height:100%;position:absolute;left:0;right:0;top:0;bottom:0}.fadeout{animation-name:fadeout;z-index:2;animation-iteration-count:1;animation-duration:5s;background-color:#000}.fadeout,.red{width:100%;height:100%;position:absolute;left:0;right:0;top:0;bottom:0}.red{animation-name:red;z-index:1;animation-iteration-count:1;animation-duration:3s;transition-timing-function:cubic-bezier(0,0,1,2.19)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Effects/styles.sass
// module id = 115
// module chunks = 0